import {
  library as fontAwesomeLibrary,
  dom,
} from '@fortawesome/fontawesome-svg-core';

import {
  mdiLogout,
  mdiFish,
  mdiViewDashboard,
  mdiAccountMultiple,
  mdiMap,
  mdiClipboard,
  mdiChevronRight,
  mdiChevronLeft,
  mdiPlay,
  mdiRepeat,
  mdiEye,
  mdiEyeOff,
  mdiPlus,
  mdiCheckboxMarkedCircleOutline,
  mdiClose,
  mdiChevronDown,
  mdiPencil,
  mdiDelete,
  mdiUpload,
  mdiCloud,
  mdiMagnify,
  mdiFinance,
  mdiArrowUp,
  mdiDeleteAlert,
  mdiMapMarker,
  mdiMapMarkerRadius,
  mdiViewGrid,
  mdiCalendar,
  mdiMenu,
  mdiAccountGroup,
  mdiSquareEditOutline,
  mdiHelpCircleOutline,
  mdiCalendarRemove,
  mdiMinus,
  mdiFishbowl,
  mdiMenuDown,
  mdiDotsHorizontal,
  mdiExclamationThick,
  mdiAlert,
  mdiWeb,
  mdiBriefcase,
  mdiCheckBoxOutline,
  mdiCheckboxBlankOutline,
  mdiAccountBoxOutline,
  mdiCloudDownload,
  mdiInformation,
  mdiWifi,
} from '@mdi/js';

import {
  faUser,
  faCheckCircle,
  faPlay,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faSort,
} from '@fortawesome/free-solid-svg-icons';

import { faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';

fontAwesomeLibrary.add(
  faUser,
  faCheckCircle,
  faPlay,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faSort,
  faCcMastercard,
  faCcVisa
);

export const icons = {
  users: mdiAccountMultiple,
  group: mdiAccountGroup,
  groupOutline: mdiAccountBoxOutline,
  fish: mdiFish,
  logout: mdiLogout,
  dashboard: mdiViewDashboard,
  map: mdiMap,
  clipboard: mdiClipboard,
  arrowRight: mdiChevronRight,
  arrowLeft: mdiChevronLeft,
  play: mdiPlay,
  repeat: mdiRepeat,
  show: mdiEye,
  checkCircle: mdiCheckboxMarkedCircleOutline,
  hide: mdiEyeOff,
  plus: mdiPlus,
  minus: mdiMinus,
  clear: mdiClose,
  prev: mdiChevronLeft,
  next: mdiChevronRight,
  dropdown: mdiChevronDown,
  download: mdiCloudDownload,
  search: mdiMagnify,
  sort: mdiArrowUp,
  edit: mdiPencil,
  delete: mdiDelete,
  deleteAlert: mdiDeleteAlert,
  upload: mdiUpload,
  uploaded: mdiCloud,
  graduated: mdiCalendarRemove,
  statistics: mdiFinance,
  marker: mdiMapMarker,
  markerAlt: mdiMapMarkerRadius,
  viewGrid: mdiViewGrid,
  menu: mdiMenu,
  calendar: mdiCalendar,
  editOutline: mdiSquareEditOutline,
  questionOutline: mdiHelpCircleOutline,
  masterCard: 'fab fa-cc-mastercard',
  visa: 'fab fa-cc-visa',
  fishFamily: mdiFishbowl,
  expand: mdiChevronDown,
  close: mdiClose,
  down: mdiMenuDown,
  dots: mdiDotsHorizontal,
  info: mdiExclamationThick,
  warning: mdiAlert,
  success: mdiCheckboxMarkedCircleOutline,
  business: mdiBriefcase,
  web: mdiWeb,
  checkboxOn: mdiCheckBoxOutline,
  checkboxOff: mdiCheckboxBlankOutline,
  information: mdiInformation,
  wifi: mdiWifi,
};

export const fontAwesomeDom = dom;
